import script from "./ThemeSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemeSwitch.vue?vue&type=script&setup=true&lang=js"

import "./ThemeSwitch.vue?vue&type=style&index=0&id=a17a4a04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a17a4a04"]])

export default __exports__